var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a4cdde44-0661-4cc4-a06f-f2a60419b616",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-a98c3e83-216f-4f29-80c1-bcbe6b4a262d{fill:#fff;}.uuid-eb8fdd0a-5817-4dcc-904c-61e5467b599d{fill:#002366;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-eb8fdd0a-5817-4dcc-904c-61e5467b599d",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-5c2d3507-3f6f-4b88-a4b9-eb220dddf7d3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-808787f5-8ee1-47ff-b674-9ac3c82db73a",
    className: "uuid-a98c3e83-216f-4f29-80c1-bcbe6b4a262d",
    d: "m95.13,166.99h73.5v204.53h28.52v-204.53h73.51v-26.52H95.13v26.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-ead6bac9-85f3-4186-a4e1-9df0bf401b37",
    className: "uuid-a98c3e83-216f-4f29-80c1-bcbe6b4a262d",
    d: "m327.3,259.42h77.92v-26.12h-77.92v-66.3h86.36v-26.52h-114.88v231.06h118.09v-26.52h-89.57v-85.59Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTell);
export default __webpack_public_path__ + "static/media/icon_tell.450d9469cdba365c0f5518a047d6215c.svg";
export { ForwardRef as ReactComponent };